import { colors, H4 } from 'ui/theme';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { Link } from 'ui/links';
import {
  Container,
  ContainerText,
  ContainerBody,
  AnimatedBorderCardContainer,
  AnimatedBorderCardContentWrapper,
  TrackWrapper,
  Track,
  StyledTrack,
  Card,
  StatusSection,
} from './DataSyncEmpty.styles';
import { DESTINATIONS_LIST } from 'modules/dataSync/constants/prequel';

export const DataSyncEmpty = () => {
  const { t } = useDataSyncTranslations();

  const baseDestinationData = Object.values(DESTINATIONS_LIST).map((destination) => ({
    id: destination.id,
    destinationName: destination.name,
    destinationIcon: <destination.Icon height={24} width={24} />,
  }));

  // Add the first item to the end to create a continuous flow without flicker
  const destinationData = [...baseDestinationData, baseDestinationData[0]];

  type RenderDestinationsProps = {
    index?: number;
    isdestinationName?: boolean;
    isStatic?: boolean;
  };

  const renderDestinations = ({
    index,
    isdestinationName,
    isStatic,
  }: RenderDestinationsProps = {}) => {
    const content =
      index !== undefined
        ? isdestinationName
          ? destinationData[index].destinationName
          : destinationData[index].destinationIcon
        : destinationData.map((card) =>
            isdestinationName ? card.destinationName : card.destinationIcon,
          );

    if (index !== undefined) {
      return (
        <Card data-destination-name={isdestinationName} data-static={isStatic}>
          {content}
        </Card>
      );
    }

    return (content as (string | JSX.Element)[]).map((item, i) => (
      <Card
        key={`${isdestinationName ? 'destinationName' : 'destinationIcon'}-${i}`}
        data-destination-name={isdestinationName}
        data-static={isStatic}
      >
        {item}
      </Card>
    ));
  };

  return (
    <>
      <Container data-test="data-sync-empty-container">
        <AnimatedBorderCardContainer data-static="true">
          <AnimatedBorderCardContentWrapper>
            <TrackWrapper>
              <Track data-static="true">
                {renderDestinations({ index: 1, isdestinationName: true, isStatic: true })}
              </Track>
              <StyledTrack data-delayed="true" data-static="true">
                {renderDestinations({ index: 1 })}
              </StyledTrack>
              <StatusSection data-static="true">
                <Badge data-test="badge-static-icon" variant={BADGE_VARIANTS.RUNNING}>
                  {t('status.healthy')}
                </Badge>
                <div>Synced 30 minutes ago</div>
              </StatusSection>
            </TrackWrapper>
          </AnimatedBorderCardContentWrapper>
        </AnimatedBorderCardContainer>
        <AnimatedBorderCardContainer>
          <AnimatedBorderCardContentWrapper>
            <TrackWrapper>
              <Track>{renderDestinations({ isdestinationName: true })}</Track>
              <StyledTrack data-delayed="true">{renderDestinations()}</StyledTrack>
              <StatusSection>
                <Badge variant={BADGE_VARIANTS.RUNNING}>{t('status.healthy')}</Badge>
                <div>Synced 30 minutes ago</div>
              </StatusSection>
            </TrackWrapper>
          </AnimatedBorderCardContentWrapper>
        </AnimatedBorderCardContainer>
        <AnimatedBorderCardContainer data-static="true">
          <AnimatedBorderCardContentWrapper>
            <TrackWrapper>
              <Track data-static="true">
                {renderDestinations({ index: 2, isdestinationName: true, isStatic: true })}
              </Track>
              <StyledTrack data-delayed="true" data-static="true">
                {renderDestinations({ index: 2 })}
              </StyledTrack>
              <StatusSection data-static="true">
                <Badge variant={BADGE_VARIANTS.RUNNING}>{t('status.healthy')}</Badge>
                <div>Synced 30 minutes ago</div>
              </StatusSection>
            </TrackWrapper>
          </AnimatedBorderCardContentWrapper>
        </AnimatedBorderCardContainer>
      </Container>
      <ContainerText>
        <H4>{t('empty.noDestinations')}</H4>
        <ContainerBody color={colors.textSecondary}>
          {`${t('empty.learnMore')} `}
          <Link href="tbd_replaceme">{t('empty.knowledgeCenter')}</Link>
          {` .`}
        </ContainerBody>
      </ContainerText>
    </>
  );
};
